<template>
    <div>
        <COMMENTS
                :comments-list="comments.body"
                :total="comments.page.count"
                :page-num="comments.page.page_num"
                :page-size="comments.page.page_size"
                :loading="commentsLoading"
                :page-change="pageChange"
                :submit-comments="submitComment"
                :delete-comments="deleteComments"
        >

        </COMMENTS>
    </div>
</template>

<script>
    import COMMENTS from '../../common/comments'
    import {mapActions,mapState} from 'vuex'

    export default {
        components: {
            COMMENTS
        },
        name: 'Comment',
        props: {
            blogId: null,
        },
        data() {
            return {
                commentsLoading:false,
                currentContestId:0,
                pageSize:10,
                pageNum:1,
                total:20,
                //评论内容
                inputComment: '',
                //输入框默认内容
                placeholders: '写下你的评论',
                comments: {
                    body:[],
                    page:{
                        page_num:0,
                        page_size:0,
                        count:0,
                    }
                },

            }
        },

        methods: {
            ...mapActions({
                getContestCommentsList:'contest/getContestCommentsList',
                setContestComment:'contest/setContestComment',
                deleteContestComment:'contest/deleteContestComment',
            }),
            // 分页变动
            pageChange(page){
                this.pageNum = page;
                this.getCommentsList();
            },
            //提交评论
            submitComment(obj){
                let _this = this;
                this.setContestComment({
                    contest_id:this.currentContestId,
                    data:{
                        reply_id:obj.reply_id,
                        comment:obj.comment,
                    },
                    callback:function (response) {
                        _this.getCommentsList();
                        _this.$Message.success("评论成功")
                    }
                });
            },
            // 删除竞赛评论，只能删除自己的
            deleteComments(commentId){
                let _this = this;
                this.deleteContestComment({
                    data:{
                        contest_id:_this.currentContestId,
                        ids:[commentId]
                    },
                    callback:res=>{
                        _this.$Message.success("删除成功");
                        _this.getCommentsList();
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            },
            /**
             * 点击取消按钮
             */
            cancel() {
                this.inputComment = '';
                this.placeholders = '写下你的评论';
            },
            getCommentsList(){
                let _this = this;
                _this.getContestCommentsList({
                    data: {
                        contest_id:this.currentContestId,
                        data: {
                            page_num: _this.pageNum,
                            page_size: _this.pageSize,
                        }
                    },
                    callback:res=>{
                        _this.comments = res;
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            }
        },
        computed:{
            ...mapState({
                commentsList: state => state.contest.contest_comments_list
            })
        },
        mounted() {
            let id = this.$route.params.id;
            if (id > 0) {
                this.currentContestId = id;
                // 加载评论
                this.getCommentsList()
            }else{
                this.$router.push({
                    name:'contest'
                })
            }
        }
    }

</script>

<style scoped lang="less">
    .reply {
        margin-left: 15px;
    }

</style>
